<template>
  <div class="wrapper">
    <div class="page-header">
      <div class="page-ribbon">
        <div class="path">
          <img src="@/assets/admin-icon/customers-active.svg" />
          <pathViewer></pathViewer>
        </div>
        <div class="ribbon-options"></div>
      </div>
    </div>
    <div class="page-body">
      <div class="tab-body">
        <multipane class="custom-resizer" layout="vertical">
          <div class="left-container">
            <div class="filter-widget">
              <div class="search-widget">
                <img src="@/assets/icons/search.svg" alt />
                <input type="text" placeholder="Type in to Search…" />
              </div>
              <div class="spacer"></div>
              <DropdownButton class="default" :content="[
                { name: 'Select All', value: 'all' },
                { name: 'Accounts', value: 'custom' },
                { name: 'Schools', value: 'Schools' },
              ]">Select type here</DropdownButton>
              <div class="spacer"></div>
              <DropdownButton class="default" :content="[
                { name: 'Select All', value: 'all' },
                { name: 'Managers', value: 'custom' },
                { name: 'Schools', value: 'Schools' },
              ]">Select</DropdownButton>
            </div>
            <div class="filter-result-widget">
              <div class="search-result-header">
                Consultants, Managers & Contacts
              </div>
              <div class="search-item">
                <img src="@/assets/avatar.png" />
                <div class="content">
                  <label>Abe jahwin</label>
                  <div class="info-widget">
                    <div class="info-item">Consultified AB</div>
                  </div>
                </div>
              </div>
              <div class="search-item">
                <img src="@/assets/avatar.png" />
                <div class="content">
                  <label>Abe jahwin</label>
                  <div class="info-widget">
                    <div class="info-item">Consultified AB</div>
                  </div>
                </div>
              </div>
              <div class="search-result-header">Schools & Accounts</div>
              <div class="search-item">
                <img src="@/assets/avatar.png" />
                <div class="content">
                  <label>Abe jahwin</label>
                  <div class="info-widget">
                    <div class="info-item">Consultified AB</div>
                  </div>
                </div>
              </div>
              <div class="search-result-header">
                Tasks, Leads and Candidates
              </div>
              <div class="search-item">
                <div class="icon task">
                  <img src="@/assets/admin-icon/news_letter/task.svg" />
                </div>
                <div class="content">
                  <label>Reviewing the report 2020</label>
                  <div class="info-widget">
                    <div class="info-item divider">Task</div>
                    <div class="info-item">November 3, 2014</div>
                  </div>
                </div>
              </div>
              <div class="search-item">
                <div class="icon leads">
                  <img src="@/assets/admin-icon/news_letter/leads.svg" />
                </div>
                <div class="content">
                  <label>Reviewing the report 2020</label>
                  <div class="info-widget">
                    <div class="info-item divider">Leads</div>
                    <div class="info-item">November 3, 2014</div>
                  </div>
                </div>
              </div>
              <div class="search-item">
                <div class="icon candidates">
                  <img src="@/assets/admin-icon/news_letter/candidates.svg" />
                </div>
                <div class="content">
                  <label>Reviewing the report 2020</label>
                  <div class="info-widget">
                    <div class="info-item divider">Candidates</div>
                    <div class="info-item">November 3, 2014</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <multipane-resizer></multipane-resizer>
          <div class="right-container" :style="{ flexGrow: 1 }">
            <div class="compose-email-header">
              <DropdownButton class="blue" :content="[
                { name: 'Email', value: 'all' },
                { name: 'News Letter', value: 'custom' },
              ]">Compose</DropdownButton>
            </div>
            <div class="compose-email-body">
              <html-editor placeholder="Compose email message" class="notes-editor-widget" id="edit-descr" />
              <div class="compose-email-footer">
                <button class="btn-send">Send</button>
              </div>
            </div>
          </div>
        </multipane>
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
  components: {},
  data: () => ({}),
  mounted() {
    let vm = this;
    let path = [
      {
        label: "News Letter & Emails",
      },
    ];
    vm.$store.commit("SET_PATH", path);
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #dfdfdf;

  .page-header {
    height: 41px;
    background: #dfdfdf;

    .page-ribbon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 41px;
      padding: 0px 15px;

      .path {
        color: #0884af;
        font-size: 13px;
        display: flex;
        align-items: center;

        img {
          width: 20px;
          margin-right: 6px;
        }

        span {
          margin-top: 4px;
        }
      }

      .ribbon-options {
        display: flex;
        align-items: center;

        .btn-search {
          border: none;
          background: transparent;

          img {
            width: 13px;
            object-fit: contain;
          }
        }

        .btn-customer-user {
          background: transparent;
          border: none;
          display: flex;
          align-items: center;

          .profile-logo {
            width: 15px;
            height: 15px;
            object-fit: cover;
            border-radius: 50%;
            margin-right: 5px;
          }

          span {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .page-body {
    overflow-y: auto;
    height: calc(100% - 42px);

    .tab-body {
      height: calc(100% - 47px);
      width: 100%;
      overflow-y: unset;
      height: 100%;
      position: relative;
      padding: 10px;
      padding-top: 0px;

      .custom-resizer {
        height: 100%;
      }

      .active {
        border-left: 2px solid #ccc;
      }

      .left-container {
        background: #fff;
        border-radius: 5px;
        height: 100%;
        overflow-y: auto;
        min-width: 40%;
        width: 50%;
        max-width: 50%;
        padding: 15px 16px;

        .filter-widget {
          height: 160px;

          .search-widget {
            border: 1px solid #ccc;
            height: 45px;
            display: flex;
            align-items: center;
            padding: 0px 10px;
            border-radius: 5px;

            img {
              width: 25px;
              height: 25px;
            }

            input {
              height: 42px;
              width: 100%;
              padding-left: 15px;
              outline: none;
              border: none;
            }
          }

          .spacer {
            margin-bottom: 10px;
          }
        }

        .filter-result-widget {
          height: calc(100% - 160px);
          overflow-y: auto;

          .search-result-header {
            color: #999faa;
            padding-bottom: 6px;
            border-bottom: 1px solid #e9e9e9;
            margin-bottom: 15px;
          }

          .search-item {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            padding: 8px;
            cursor: pointer;
            border-radius: 5px;

            &:hover {
              background: rgb(241, 241, 241);
            }

            img {
              width: 40px;
              height: 40px;
              object-fit: cover;
              border-radius: 50%;
            }

            .icon {
              height: 40px;
              width: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;

              &.task {
                background: #ffc273;
              }

              &.leads {
                background: #1ba5a4;
              }

              &.candidates {
                background: #0884af;
              }

              img {
                width: 25px;
                height: 25px;
                object-fit: contain;
              }
            }

            .content {
              display: flex;
              flex-direction: column;

              label {
                padding-left: 10px;
                display: block;
                margin-bottom: 5px;
                font-size: 15px;
              }

              .info-widget {
                display: flex;
                align-items: center;

                .info-item {
                  color: #999faa;
                  padding: 0px 10px;

                  &.divider {
                    border-right: 1px solid #999faa;
                  }
                }
              }
            }
          }
        }
      }

      .right-container {
        padding-right: 10px;
        height: 100%;
        padding-bottom: 100px;
        width: 50%;
        min-width: 40%;
        max-width: 60%;
        background: #fff;
        border-radius: 5px;

        .compose-email-header {
          padding: 15px 20px;
          height: 70px;
        }

        .compose-email-body {
          padding-left: 20px;
          height: calc(100% - 70px);
          overflow-y: auto;

          .notes-editor-widget {
            border: 1px solid #ddd;
          }

          .compose-email-footer {
            padding-top: 20px;

            .btn-send {
              width: 164px;
              height: 47px;
              background: #1ba5a4;
              border-radius: 5px;
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
